import React from "react"
import * as Yup from "yup"
import { Formik, Form, Field, ErrorMessage, useFormikContext } from "formik";
import styled from "styled-components"

const Champ = styled.div`
margin:10px;
padding:5px;
float:left;
display: inline-flex;
width:100%;
`

const Label = styled.label`
padding: 5px;
min-width: 250px;
`

const LienAssociation = styled.div`
margin:10px;
padding:5px;
float: left;
background-color: #acacac;
min-width: 66%;
`

const ElementForm = (params) => {

  const {typeAction, typeElement, initialValues, onSubmit} = params

  const proprietesUtiles =
  { theatre: ['site', 'site_antique', 'specifique', 'type_ed'
      , 'localite', 'pres_coord', 'abreviation', 'lieu_dit', 'lat', 'long'
      , 'lat_dec', 'long_dec', 'geonames_complet', 'geonames_texte_fr'],
    phototheatre:['nom_fichier', 'date_photo', 'pays', 'url_locale', 'photo'
      , 'legende', 'url_nakala', 'copyright', 'theatre_id'],
    collaborateur:['nom', 'prenom', 'note', 'initiales'],
    auteur:['nom', 'prenom'],
    motclef:['libelle', 'code', 'categorie', 'order'],
    notice:['identifiant_zotero', 'reference_biblio'],
    user:['nom', 'prenom', 'email', 'sesame', 'sesame_confirmation', 'role']
  }

  const initialiseFormulaire = (cles) => {
    let retour = {}
    if (cles) {
      for(const cle of cles){
        //cas particulier du mot de passe
        if (cle.includes("sesame")){
          initialValues[cle] = ""
        }
        retour[cle] = initialValues[cle] ? initialValues[cle] : ''
      }
    }
    return retour
  }

  const FormulaireJSX = (prop) => {

      // returns all values and methods from your Formik tag
    const formikProps = useFormikContext()

    const handleChange = (event) => {
      formikProps.setFieldValue("photo", event.target.files[0])
    }

    const {typeElement} = prop
    switch (typeElement){
      case 'theatre' :
          return(<Form>
          <Champ>
            <Label>Site</Label>
            <Field name="site" type="text" className="form-control" size="40"/>
            <ErrorMessage name="site" className="d-block invalid-feedback" component="span"/>
          </Champ>
          <br/>
          <Champ>
            <Label>Site Antique</Label>
            <Field name="site_antique" type="text" className="form-control" size="40" />
          </Champ>
          <br/>
          <Champ>
          <Label>Localité</Label>
          <Field name="localite" type="text" className="form-control" size="40" />
          <ErrorMessage name="localite" className="d-block invalid-feedback" component="span"/>
          </Champ>
          <br/>
          <Champ>
            <Label>Lieu dit</Label>
            <Field name="lieu_dit" type="text" className="form-control" size="40" />
          </Champ>
          <br/>
          <Champ>
          <Label>Localisation</Label>
            <Field name="pres_coord" type="radio" className="form-control"  value="localise"/>Localisé
            <Field name="pres_coord" type="radio" className="form-control"  value="non_localise"/>Non Localisé
            <Field name="pres_coord" type="radio" className="form-control"  value="texte"/>Attesté par les textes
          </Champ>
          <br/>
          <Champ>
          <Label>Type d'édifice</Label>
            <Field name="type_ed" type="radio" className="form-control" value="theatre"/>Theatre
            <Field name="type_ed" type="radio" className="form-control" value="odeon"/>Odeon
            <Field name="type_ed" type="radio" className="form-control" value="autre"/>Autre
          </Champ>
          <br/>
          <Champ>
            <Label>Dénomination spécifique</Label>
            <Field name="specifique" type="text" className="form-control" size="40" />
          </Champ>
          <br/>
          <Champ>
            <Label>Abreviation</Label>
            <Field name="abreviation" type="text" className="form-control" size="40" />
          </Champ>
          <br/>
          <Champ>
          <Label>Latitude (format degré minute seconde N)</Label>
          <Field name="lat" type="text" className="form-control" size="30" />
          </Champ>
          <br/>
          <Champ>
          <Label>Longitude  (format degré minute seconde E)</Label>
          <Field name="long" type="text" className="form-control" size="30" />
          </Champ>
          <br/>
          <Champ>
          <Label>Latitude (en décimal)</Label>
          <Field name="lat_dec" type="number" className="form-control" size="30"/>
          </Champ>
          <br/>
          <Champ>
          <Label>Longitude (en décimal)</Label>
          <Field name="long_dec" type="number" className="form-control" size="30"/>
          </Champ>
          <br/>
          <Champ>
          <Label>Identifiant Géonames (Continent à Localité)</Label>
          <Field name="geonames_complet" type="text" className="form-control"  size="40"/>
          </Champ>
          <Champ>
          <Label>Libellé Géonames (Continent à Localité)</Label>
          <Field name="geonames_texte_fr" type="text" className="form-control" size="40" />
          </Champ>
          <br/>
          <Champ>
          <button type="submit" onSubmit={onSubmit}>Envoyer</button>
          </Champ>
        </Form>)
      case 'phototheatre':
        return(<Form encType="multipart/form-data">
          <Champ>
              <Label>Nom du fichier</Label>
              <Field name="nom_fichier" type="text" className="form-control" size="40" />
              <ErrorMessage name="nom_fichier" className="d-block invalid-feedback" component="span"/>
          </Champ>
          <br/>
          <Champ>
              <Label>Date de la photo</Label>
              <Field name="date_photo" type="text" className="form-control" size="40" />
              <ErrorMessage name="date_photo" className="d-block invalid-feedback" component="span"/>
         </Champ>
          <br/>
          <Champ>
              <Label>Légende</Label>
              <Field name="legende" type="text" className="form-control" size="40" />
           </Champ>
           <br/>
          <Champ>
              <Label>Pays</Label>
              <Field name="pays" type="text" className="form-control" size="40" />
           </Champ>
           <br/>
          <Champ>
            <Label>Copyright</Label>
            <Field name="copyright" type="text" className="form-control" size="40" />
          </Champ>
          <br/>
          <Champ>
            <Label>Fichier</Label>
            <Field name="photo_interface"
              type="file"
              className="form-control"
              onChange={handleChange}
              />
             <ErrorMessage name="photo" className="d-block invalid-feedback" component="span"/>
             <Field name="photo"
              type="hidden"
              />
          </Champ>
          <br/>
          <Champ>
          <button type="submit" onSubmit={onSubmit}>Envoyer</button>
          </Champ>
        </Form>)
         case 'collaborateur':
          return(<Form>
            <Champ>
                <Label>Nom</Label>
                <Field name="nom" type="text" className="form-control" size="40" />
                <ErrorMessage name="nom" className="d-block invalid-feedback" component="span"/>
            </Champ>
            <br/>
            <Champ>
                <Label>Prénom</Label>
                <Field name="prenom" type="text" className="form-control" size="40" />
             </Champ>
             <br/>
            <Champ>
              <Label>Initiales</Label>
              <Field name="initiales" type="text" className="form-control" size="40" />
              <ErrorMessage name="initiales" className="d-block invalid-feedback" component="span"/>
            </Champ>
            <br/>
            <Champ>
              <Label>Note</Label>
              <Field name="note" as="textarea" className="form-control" rows="10"  cols="60"/>
            </Champ>
            <br/>
            <Champ>
            <button type="submit" onSubmit={onSubmit}>Envoyer</button>
            </Champ>
          </Form>)
        case 'user':
          return(<Form>
            <Champ>
              <Label>Prénom</Label>
              <Field name="prenom" type="text" className="form-control" size="40" />
            </Champ>
            <br/>
            <Champ>
              <Label>Nom</Label>
              <Field name="nom" type="text" className="form-control" size="40" />
              <ErrorMessage name="nom" className="d-block invalid-feedback" component="span"/>
            </Champ>
            <br/>
            <Champ><Label>Email</Label>
            <Field name="email" type="text" autoComplete="username" className="form-control" size="40" />
            <ErrorMessage name="email" className="d-block invalid-feedback" component="span"/>
            </Champ>
            <br/>
            <Champ><Label>Role</Label>
            <Field name="role" type="radio" className="form-control" value="membre"/>Membre
            <Field name="role" type="radio" className="form-control" value="admin"/>Admin
            </Champ>
            <br/>
            <Champ><Label>Mot de passe</Label>
            <Field name="sesame" type="password" className="form-control" size="40"/>
            <ErrorMessage name="sesame" className="d-block invalid-feedback" component="span"/>
            </Champ>
            <Champ><Label>Mot de passe (confirmation)</Label>
            <Field name="sesame_confirmation" type="password"  className="form-control" size="40" />
            <ErrorMessage name="sesame_confirmation" className="d-block invalid-feedback" component="span"/>
            </Champ>
            <br/>
            <button type="submit" onSubmit={onSubmit}>Envoyer</button>
          </Form>)
        case 'auteur':
          return(<Form>
            <Champ>
              <Label>Prénom</Label>
              <Field name="prenom" type="text" className="form-control" size="40" />
            </Champ>
            <br/>
            <Champ>
              <Label>Nom</Label>
              <Field name="nom" type="text" className="form-control" size="40" />
              </Champ>
            <br/>
            <button type="submit" onSubmit={onSubmit}>Envoyer</button>
          </Form>)
        case 'motclef':
          return(<Form>
            <Champ>
              <Label>Libellé</Label>
              <Field name="libelle" type="text" className="form-control" size="40" />
              <ErrorMessage name="libelle" className="d-block invalid-feedback" component="span"/>
            </Champ>
            <br/>
            <Champ>
              <Label>Code</Label>
              <Field name="code" type="text" className="form-control" size="40" />
              </Champ>
            <br/>
            <Champ>
              <Label>Order</Label>
              <Field name="order" type="text" className="form-control" size="40" />
              <ErrorMessage name="order" className="d-block invalid-feedback" component="span"/>
              </Champ>
            <br/>
            <Champ>
              <Label>Catégorie</Label>
              <Field name="categorie" type="radio" className="form-control" value="standard" checked/>Standard
              <Field name="categorie" type="radio" className="form-control" value="theme"/>Thème
              <Field name="categorie" type="radio" className="form-control" value="reference"/>Référence
              <Field name="categorie" type="radio" className="form-control" value="synthese"/>Synthèse
            </Champ>
            <br/>
            <button type="submit" onSubmit={onSubmit}>Envoyer</button>
          </Form>)
        case 'notice':
          return(<Form>
            <Champ>
              <Label>Référence bibliographique</Label>
              <Field name="reference_biblio" as="textarea" className="form-control" rows="10"  cols="60"/>
            </Champ>
            <br/>
            <Champ>
              <Label>Identifiant Zotero</Label>
              <Field name="identifiant_zotero" type="text" className="form-control" size="40" />
            </Champ>
            <button type="submit" onSubmit={onSubmit}>Envoyer</button>
          </Form>)
      default:
        return(<Form>Type non traité (prise en charge par Zotero uniquement ?)</Form>)
    }
  }
  const SUPPORTED_FORMATS = ["image/jpg", "image/png", "image/jpeg", "image/gif"]

  const testTaille = (fichier) => {
    console.log("taille fichier " + fichier.size)
    const TAILLE_MAX = 5*1024*1024
    const retour = (fichier.size<TAILLE_MAX) ? true : false
    return  retour
  }

  const validationSchemaParType = (typeElement) => {
    switch (typeElement) {
      case 'theatre' :
        return ({
          site: Yup.string().required("Obligatoire"),
          localite: Yup.string().required("Obligatoire"),
          geoname_id:Yup.number().integer("Identifiant geonames invalide")
        })
      case 'motclef' :
        return({
          order: Yup.number().integer("Entier permettant de définir l'ordre d'affichage des mots clefs"),
          libelle: Yup.string().required("Obligatoire"),
          categorie: Yup.string().required("Obligatoire")
      })
      case 'collaborateur' :
        return ({
          nom: Yup.string().required("Obligatoire"),
          initiales: Yup.string().required("Obligatoire")
        })
      case 'phototheatre' :
        return ({
          nom_fichier: Yup.string().required("Obligatoire"),
          photo: Yup.mixed()
            .test(
              "size",
              "Taille de fichier trop importante",
              value => (value) ? testTaille(value) : true
            )
            .test(
              "type",
              "Type de fichier invalide",
              value => (value) ? SUPPORTED_FORMATS.includes(value?.type) : true
            )
        })
      case 'user' :
      return ({
        nom: Yup.string().required("Obligatoire"),
        email: Yup.string().email('Email incorrect').required('Obligatoire'),
        sesame: Yup.string().required('Obligatoire'),
        sesame_confirmation: Yup.string()
          .oneOf([Yup.ref('sesame'), null], 'Les mots de passe doivent correspondre'),
        })
      default :
      //pas de vérification de champ
      return ({})
    }
  }

  const validationSchema = Yup.object().shape(validationSchemaParType(typeElement))

  const urlAssociation = (typeCible) => {
    const lien = `/association/${typeElement}/${initialValues.id}/${typeCible}`
    return lien
  }

  const FormWrapper = () => {
        return (<Formik
          initialValues={initialiseFormulaire(proprietesUtiles[typeElement])}
          validationSchema={validationSchema}
          onSubmit={onSubmit}>
          <FormulaireJSX typeElement={typeElement}/>
        </Formik>)
  }

  const AfficheRelations = () => {
    switch(typeElement){
      case 'theatre' :
        return (<LienAssociation>
          <a href={urlAssociation('phototheatre')}>Modifier les photos associées </a>
        </LienAssociation>)
      case 'motclef':
        return (<LienAssociation>
          <a href={urlAssociation('motclef')}>Modifier le motClef parent associé</a>
        </LienAssociation>)
      default:
        return
    }
  }


  return(
    <>
      {typeAction === 'Modifier' ? AfficheRelations(): null}
      {FormWrapper()}
    </>
  )
}
export default ElementForm